import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { datadogRum } from '@datadog/browser-rum';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.datadog_enable) {
  datadogRum.init({
    applicationId: environment.datadog_application_id,
    clientToken: environment.datadog_client_token,
    site: 'datadoghq.com',
    service: 'tech-app-bms',
    env: environment.datadog_env,
    version: environment.geeks2u_app_version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: (event) => {
      if (event.type === 'error' && event.error && event.error.message && event.error.message.includes("undefined is not an object (evaluating 'H1.isProxied')")) {
        return false;
      }
      return true;
    }
  });
  datadogRum.startSessionReplayRecording();
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    console.error('Bootstrap Error:', err);
  });
